module.exports = __webpack_public_path__ + "static/img/fax_header.e4b9096.png";


//////////////////
// WEBPACK FOOTER
// ./static/help-image/fax_header.png
// module id = 84
// module chunks = 1